import { HOST, APP_LANGUAGE } from '../index';

/**
 * @name GENERIC_TOKEN
 * @constant
 * @description Signifies a replacment that needs to be made for the generic part name
 */
export const GENERIC_TOKEN = '{generic}';

/**
 * @name PAGE_FIRST
 * @constant
 * @description Identifies the first page 
 */
export const PAGE_FIRST = 'first';

/**
 * @name PAGE_LAST
 * @constant
 * @description Identifies the last page 
 */
export const PAGE_LAST = 'last';

/**
 * @name PAGE_SIZE
 * @constant
 * @description Determines the size of the chunks that are displayed in the table
 */
export const PAGE_SIZE = 25;

/**
 * @name ALL_PAGE_SIZE
 * @constant
 * @description Determines all the sizes of the chunks that are displayed in the table
 */
export const ALL_PAGE_SIZES = [25, 50, 100];

/**
 * @name PAGE_NEXT
 * @constant
 * @description Identifies the next page 
 */
export const PAGE_NEXT = 'next';

/**
 * @name PAGE_PREVIOUS
 * @constant
 * @description Identifies the previous page 
 */
export const PAGE_PREVIOUS = 'previous';

/**
 * @name SELECT_ALL
 * @constant
 * @description Identifies the select all checkbox
 */
 export const SELECT_ALL = 'selectAll';

/**
 * @name PRODUCT_URL
 * @constant
 * @description Tokenized product URL (e.g. `https://analog.com/en/products/{generic}`)
 */
export const PRODUCT_URL = `//${ HOST }/${ APP_LANGUAGE }/products/${ GENERIC_TOKEN }`;
/**
 * @name BREADCRUMB_URL
 * @constant
 * @description Tokenized Breadcrumb URL (e.g. `https://analog.com/en{/generic}`)
 */
export const BREADCRUMB_URL = `//${ HOST }/${ APP_LANGUAGE }${ GENERIC_TOKEN }`;

/**
 * @name PRODUCT_DATASHEET_URL
 * @constant
 * @description Tokenized product datasheet URL (e.g. `https://analog.com/en/{generic}/datasheet`)
 */
export const PRODUCT_DATASHEET_URL = PRODUCT_URL.replace("/products","") + '/datasheet';

/**
 * @name PRODUCT_DESIGN_URL
 * @constant
 * @description Tokenized product reference circuit URL (e.g. `https://analog.com/en/{generic}#product-designs`)
 */
export const PRODUCT_DESIGN_URL = PRODUCT_URL + '#product-designs';

/**
 * @name PRODUCT_DOCUMENTATION_URL
 * @constant
 * @description Tokenized product documentation URL (e.g. `https://analog.com/en/{generic}#product-documentation`)
 */
export const PRODUCT_DOCUMENTATION_URL = PRODUCT_URL + '#product-documentation';

/**
 * @name PRODUCT_DOCUMENTATION_DATASHEET_URL
 * @constant
 * @description Tokenized product documentation datasheet URL (e.g. `https://analog.com/en/{generic}?tab=documentation-pane-1#product-documentation`)
 */
 export const PRODUCT_DOCUMENTATION_DATASHEET_URL = PRODUCT_URL + '?tab=documentation-pane-1#product-overview';

/**
 * @name PRODUCT_SAMPLE_AND_BUY_URL
 * @constant
 * @description Tokenized product purchase URL (e.g. `https://analog.com/en/{generic}#product-samplebuy`)
 */
export const PRODUCT_SAMPLE_AND_BUY_URL = PRODUCT_URL + '/sample-buy.html';